import { call, put, takeLatest } from "redux-saga/effects";
import { sagaActions } from "./sagaActions";
import { callPostAPI } from "../API";
import { SERVER_API } from "../../helper/Constants";

function* postOrders(action) {
  try {
    const postOrderResult = yield call(() =>
      callPostAPI(SERVER_API.POST_ORDERS, action.data),
    );
    yield put({ type: sagaActions.ORDERS_POSTED, data: postOrderResult });
  } catch (e) {
    yield put({ type: sagaActions.ORDERS_FAILED, data: { error: e.message } });
    yield put({ type: sagaActions.API_FAILED, message: e.message });
  }
}

function* watchPostOrdersAsync() {
  yield takeLatest(sagaActions.ORDERS_POST_REQUEST, postOrders);
}

export default watchPostOrdersAsync;
